import { breakpoints, Col, Stack, Text, type TextStyle, useTheme } from "@rally/ui-kit";
import type { ReactNode } from "react";

export function Doorway({ title, children }: { title?: string; children: ReactNode }) {
  const theme = useTheme();

  const narrow = theme.isAtMost(breakpoints.phone);
  return (
    <Col style={{ flex: 1, alignItems: "center", justifyContent: "center", padding: theme.space[6] }}>
      <Col style={{ width: "100%", maxWidth: 380 }}>
        <Stack gap={6}>
          {title ? (
            <Text
              style={
                {
                  fontFamily: "var(--rally-brand)",
                  fontSize: 30,
                  lineHeight: 36,
                  fontWeight: "600",
                  letterSpacing: -0.4,
                  textAlign: narrow ? "center" : "left",

                  backgroundImage: `linear-gradient(100deg, ${theme.color["text.primary"]} 0em, ${theme.color.accentGradient[1]} 7.5em)`,
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                } as TextStyle
              }
            >
              {title}
            </Text>
          ) : null}
          <Stack gap={4}>{children}</Stack>
        </Stack>
      </Col>
    </Col>
  );
}
